import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { EllipsisOutlined, PlusOutlined, DownOutlined, FilterOutlined, CloseOutlined } from "@ant-design/icons";
import { Card, Col, Dropdown, message, Modal, Row, Tag, Typography, Button, Drawer, Divider } from "antd";
import { TableAction, TableTitleImage } from "../../elements/common-components/component";
import Table from "../../elements/table/component";
import { enableOrDisableUser, listUser } from "../../../api/userAPI";
import { FilterComponent } from '../../elements/filter/component';

import { ENVIRONMENT } from "../../../common/constants";
import dayjs from "dayjs";
import { useResponsive } from '../../../responsive/ResponsiveContext';
import { FilterFieldsRender } from "../../filter/component";

const UserList = () => {
    const [isVisibleModalOpen, setIsVisibleModalOpen] = useState(false);
    // const [userId, setUserId] = useState<number>();
    const [messageName, setMessageName] = useState<string[]>([]);
    const [userList, setUserList] = useState<object[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [page, setPage] = useState<number>(1);
    const [limit, setLimit] = useState<number>(10);
    const [sortField, setSortField] = useState<string>('id');
    const [sortOrder, setSortOrder] = useState<string>("DESC");
    const [filters, setFilters] = useState<any>({});
    const [currentUserSelect, setCurrentUserSelect] = useState<{ id: number, email: string, status: string }>();
    const [userLoading, setUserLoading] = useState(false);
    const [totalCount, setTotalCount] = useState({ totalCount: 0, count: 0 });
    const { isMobile } = useResponsive();
    const [filterDrawerOpen, setFilterDrawerOpen] = useState(false);

    const navigate = useNavigate();
    const { Text } = Typography;

    const userColumn: any = [
        {
            title: <span style={{ paddingLeft: '8%' }}> Name </span>,
            dataIndex: 'name',
            className: 'odd-column',
            sorter: (a: any, b: any) => a?.name?.localeCompare(b?.name),
            render: (_text: any, record: any) => (
                <TableTitleImage image={
                    record.profileImagePath ?
                        `https://${ENVIRONMENT}-image.s3.us-east-1.amazonaws.com/${record.profileImagePath}` :
                        <svg xmlns="http://www.w3.org/2000/svg" width="50" height={isMobile ? "30" : "50"} viewBox="0 0 24 24"><path fill="#9095a0" d="M20.37 21.25a.75.75 0 0 1-.75.75H4.38a.75.75 0 0 1-.75-.75c0-4.1 4.5-7.28 8.37-7.28s8.37 3.18 8.37 7.28M17.1 7.11A5.1 5.1 0 1 1 12 2a5.11 5.11 0 0 1 5.1 5.11" stroke="#fff" />
                        </svg>
                } title={record?.name} id={record?.id} />
            ),
            width: "22%",
            filtertype: 'input',
            filerVisible: true,
        },
        {
            title: "Email",
            dataIndex: "email",
            align: 'center',
            className: 'even-column',
            sorter: (a: any, b: any) => a?.email?.localeCompare(b?.email),
            render: (_text: any, record: any) => (
                <Col key={record?.id} className="table-data-col">
                    <Col>{record?.email}</Col>
                </Col>
            ),
            width: '20%',
            filtertype: 'input',
            filerVisible: true,
        },
        {
            title: "Status",
            dataIndex: "status",
            align: 'center',
            className: 'even-column',
            option: [
                { label: 'Enable', value: 'ENABLE' },
                { label: 'Disable', value: 'DISABLE' }
            ],
            sorter: (a: any, b: any) => a?.status?.localeCompare(b?.status),
            render: (_text: any, record: any) => {
                const statusStyles: Record<string, React.CSSProperties> = {
                    ["Enable"]: {
                        background: '#EFFCFAFF',
                        color: '#147567FF',
                    },
                    ["Disable"]: {
                        background: '#FDF1F5FF',
                        color: '#E8618C',
                    },
                };
                const style = {
                    width: '72px',
                    height: '28px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '12px',
                    lineHeight: '20px',
                    fontWeight: '400',
                    opacity: '1',
                    borderColor: '#00000000',
                    borderRadius: '5px',
                    ...(statusStyles[record.status] || {})
                };
                return (
                    <div key={record?.id} className="table-data-col">
                        <Tag style={style}>{record?.status}</Tag>
                    </div>
                );
            },
            width: "12%",
            filtertype: 'select',
            filerVisible: true,
        },
        {
            title: "Role",
            dataIndex: "role",
            align: 'center',
            option: [
                { label: 'Admin', value: 'ADMIN' },
                { label: 'Seller', value: 'SELLER' }
            ].sort((a: any, b: any) => a.value.localeCompare(b.value)),
            sorter: (a: any, b: any) => a?.role?.localeCompare(b?.role),
            render: (_text: any, record: any) => (
                <Col key={record?.id} className="table-data-col">
                    <Col>{record?.role}</Col>
                </Col>
            ),
            width: "13%",
            filerVisible: true,
            filtertype: 'multiselect'
        },
        {
            title: "Created At",
            dataIndex: "createdAt",
            align: 'center',
            className: 'odd-column',
            sorter: (a: any, b: any) => a?.createdAt?.localeCompare(b?.createdAt),
            render: (_text: any, record: any) => (
                <Col key={record?.id}>{dayjs(record?.createdAt)?.format('MMMM D, YYYY h:mm A')}</Col>
            ),
            width: '20%',
            filerVisible: false,
            filtertype: 'input'
        },
        {
            title: "",
            dataIndex: "Action",
            width: '6%',
            filerVisible: false,
            render: (_: any, value: { id: number, email: string, status: string }) => (
                <Dropdown
                    menu={{
                        items: TableAction(value.status === 'Enable' ? 'Disable' : 'Enable'),
                        onClick: (e) => {
                            if (['Enable', 'Disable'].includes(e.key)) {
                                // setUserId(value?.id);
                                setIsVisibleModalOpen(true);
                                setCurrentUserSelect({ ...value, status: e.key === 'Enable' ? 'ENABLE' : 'DISABLE' });
                                setMessageName(e.key === 'Enable' ? [
                                    'Are you sure you want to enable this user?',
                                    'Enabling the user will restore their access to the system.'
                                ] : [
                                    'Are you sure you want to disable this user?',
                                    'Disabling the user will prevent login and access to the system.'
                                ]
                                );
                            } else {
                                navigate(`edit/${value?.id}`, { state: { value } });
                            }
                        },
                    }}
                    trigger={["click"]}
                    placement="bottomRight"
                    overlayStyle={{ boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)" }}
                    key={value?.id}
                >
                    <div style={{ textAlign: "center" }}>
                        <EllipsisOutlined rotate={90} style={{ fontSize: 20, cursor: "pointer" }} />
                    </div>
                </Dropdown >
            ),
        },
    ];

    const fetchUserList = async () => {
        setLoading(true);
        const postData = {
            page: (filters && Object.keys(filters)?.length) ? 1 : page,
            limit,
            filters,
            sortField,
            sortOrder
        };
        try {
            const { status, data: { users, total } } = await listUser(postData);
            if (status) {
                setUserList(users);
                setTotalCount({ totalCount: total, count: users.length });
            }
        } catch (error) {
            message.error("Failed to fetch user list. Please try again later.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchUserList();
    }, [page, limit, sortOrder, sortField, filters]);

    const onChangeTable = (pagination: any, filters: any, sorter: any, extra: any) => {
        console.log(pagination, filters, sorter, extra);
        setPage(pagination.current);
        setLimit(pagination.pageSize);
        setSortField(sorter.field || 'id');
        setSortOrder((sorter.order && sorter.order === 'ascend') ? 'ASC' : 'DESC');
    };

    const onHandleFilter = (filterData: any) => {
        setFilters(filterData);
    };

    const onConfirmationCancel = () => {
        setIsVisibleModalOpen(false);
    };

    const onConfirmation = async () => {
        setUserLoading(true);
        try {
            const response = await enableOrDisableUser({
                id: currentUserSelect?.id,
                email: currentUserSelect?.email,
                status: currentUserSelect?.status
            });
            if (response.status === 'Success') {
                message.success(`${currentUserSelect?.status} the user successfully`);
                await fetchUserList();
            }
        } catch (error) {
            console.error("User Submit Error:", error);
            message.error(`User Submit Error ${error}`);
        } finally {
            setUserLoading(false);
            setIsVisibleModalOpen(false);
        }
    };

    // Mobile options menu
    const mobileMenuItems = [
        {
            key: 'filter',
            icon: <FilterOutlined />,
            label: 'Filter',
            className: 'filter-dropdown-item',
            onClick: () => setFilterDrawerOpen(true)
        },
        {
            key: 'create',
            icon: <PlusOutlined />,
            label: 'Create User',
            className: 'create-dropdown-item',
            onClick: () => navigate('add')
        }
    ];

    const filterContent = (
        
        <div className="filter-content-wrapper">
            <Row justify="space-between" align="middle" className="filter-header">
                <h3 style={{ color: "#191c55", fontWeight: "bold" }} className="filter-title">
                    <FilterOutlined /> <span style={{ letterSpacing: "0.5px", color: '#191c55' }}>Filters</span>
                </h3>
                <CloseOutlined
                    style={{ cursor: "pointer", color: "#191c55", fontSize: "16px" }}
                    className="filter-close-btn"
                    onClick={() => {
                        setFilterDrawerOpen(false);
                        // setFilters({});
                        // setFilters([]);
                    }}
                />
            </Row>
            <Divider style={{ margin: "8px 0 16px 0" }} />
            <div
                className="filter-fields-container"
                style={{
                    maxHeight: "60vh",
                    overflowY: "auto",
                    scrollbarWidth: "thin",
                    overflowX: 'hidden'
                }}
            >
                {FilterFieldsRender(["Name", "Email", "Status", "Role"],
                    setFilters,
                    filters,
                    setFilterDrawerOpen,
                    "User"
                )}
            </div>
        </div>
    );

    return (
        <>
            <Card
                className="table-card-container"
                style={{ borderTop: 'none', borderRadius: 0 }}
            >
                <Row className="table-card-header-row" align="middle" justify="space-between">
                    {isMobile ? (
                        <>
                            <Col style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                <span style={{ fontSize: 20, fontWeight: 600, flex: 1 }}>
                                    Users
                                </span>
                                <Dropdown
                                    menu={{ items: mobileMenuItems }}
                                    trigger={["click"]}
                                    placement="bottomRight"
                                    className="actions-dropdown"
                                >
                                    <Button
                                        className="action-btn menu-btn"
                                        style={{
                                            background: 'rgb(99, 106, 232)',
                                            color: 'white',
                                            border: 'none'
                                        }}
                                    >
                                        Actions <DownOutlined />
                                    </Button>
                                </Dropdown>

                            </Col>
                        </>
                    ) : (
                        <>
                            <Col style={{ width: "50%" }}>
                                <span style={{ fontSize: 20, fontWeight: 600 }}>
                                    Users
                                </span>
                            </Col>
                            <Col className="button-cols">
                                <Col className='common-filter-dropdown'>
                                    <FilterComponent
                                        columns={userColumn.filter((item: any) => item.filerVisible)}
                                        onHandleFilter={onHandleFilter}
                                    />
                                </Col>
                                <Col>
                                    <Button className="table-add-btns" onClick={() => navigate(`add`)} icon={<PlusOutlined />}><>Create User</></Button>
                                </Col>
                            </Col>
                        </>
                    )}
                </Row>
                <Table
                    columns={userColumn}
                    dataSource={userList}
                    originalData={userList}
                    setDataSource={setUserList}
                    totalCount={totalCount}
                    tabletitle="Users"
                    buttonTitle="User"
                    navigateTo="/users"
                    subpath=""
                    onChangeTable={onChangeTable}
                    loading={loading}
                    rowKey="id"
                />
            </Card>
            {/* Mobile Filter Drawer */}
            {isMobile && (
                <Drawer
                    title={null}
                    placement="right"
                    onClose={() => setFilterDrawerOpen(false)}
                    open={filterDrawerOpen}
                    width="85%"
                    className="filter-drawer"
                    bodyStyle={{ padding: 0 }}
                >
                    {filterContent}

                </Drawer>
            )}
            <Modal
                open={isVisibleModalOpen}
                onCancel={onConfirmationCancel}
                footer={null}
                closable={false}
            >
                <p>{messageName[0]}</p>
                <Text strong style={{ display: 'block', marginBottom: '16px' }}>
                    {messageName[1]}
                </Text>
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>

                    <Button
                        className="filter-btns"
                        onClick={onConfirmationCancel}
                    ><span>No</span></Button>
                    <Button
                        className="table-add-btns"
                        htmlType="submit"
                        onClick={onConfirmation}
                        loading={userLoading}
                    ><span>Yes</span></Button>
                </div>
            </Modal>
        </>
    );
};
export default UserList;